import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpStatusCode,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { ErrorsService } from "../errors/errors-service/errors.service";
import { MatSnackBar } from "@angular/material/snack-bar";

export class HttpErrorInterceptor implements HttpInterceptor {
  private _errorService = inject(ErrorsService);

  private _snackbarService = inject(MatSnackBar);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError((error) => this.handleHttpError(error)));
  }

  private handleHttpError(error: any): Observable<any> {
    const isHttpError = error instanceof HttpErrorResponse;

    const isHandledStatus = this.isHandledStatus(error.status);

    if (!isHttpError || !isHandledStatus) {
      this.showErrorSnackBar(error);
      return throwError(() => error);
    }

    console.error(error, "### HTTP ERROR");

    this.showErrorSnackBar(error);

    return throwError(() => error);
  }

  private isHandledStatus(status: number): boolean {
    return [400, 404, 500, 502, 503, 504].includes(status);
  }

  private parseErrorMessage(error: HttpErrorResponse): string | null {
    const rawError = error.error;

    const parsedError = typeof rawError === "string" ? JSON.parse(rawError) : rawError;

    if (parsedError?.message) return parsedError.message;

    return null
  }

  private showErrorSnackBar(error: HttpErrorResponse): void {
    const { status } = error;
    const message = this.parseErrorMessage(error);

    if (!this.isHandledStatus(status)) {
      this._snackbarService.open(error.message, "OK");
      return;
    }

    this._errorService.openErrorStatusCodeSnackBar(status, message ?? undefined);
  }
}
